// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".x-swipe-pane[data-v-e326978e]{background-color:#f3f6f8}.x-swipe-pane.side-left[data-v-e326978e]{height:100%;position:absolute;width:calc(100% - 4rem)}.x-swipe-pane.side-right[data-v-e326978e]{position:absolute;right:calc(-100% + 4rem);top:0;width:calc(100% - 4rem)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
